import IconButton from "components/icon-button";
import { ComponentPropsWithoutRef } from "react";
import { ReactComponent as OutlineTrash } from "assets/svg/outline-trash.svg";
import styles from "./styles.module.scss";
import useToggleModal from "hooks/useToggleModal";
import ConfirmModal from "components/confirm-modal";

const DELETE_SECTION_HEADER = "Delete section?";
const DELETE_OTHERS_HEADER = "Delete Content?";

const DELETE_SECTION_BODY =
  "Are you sure you want to delete the entire section?";
const DELETE_OTHERS_BODY = "Are you sure you want to delete this content?";

type Props = {
  onDelete: () => void;
  isSection?: boolean;
} & ComponentPropsWithoutRef<typeof IconButton>;

const Delete = ({ onDelete, isSection, ...rest }: Props) => {
  const { open, close, show } = useToggleModal(false);
  return (
    <>
      <IconButton onClick={() => open()} {...rest} className={styles["delete"]}>
        <OutlineTrash />
      </IconButton>
      <ConfirmModal
        labelTitle={isSection ? DELETE_SECTION_HEADER : DELETE_OTHERS_HEADER}
        children={isSection ? DELETE_SECTION_BODY : DELETE_OTHERS_BODY}
        show={show}
        onCancel={close}
        onConfirm={() => {
          onDelete();
          close();
        }}
      />
    </>
  );
};

export default Delete;
